export function isNotificationOfType(notification, type) {
    return notification.type === type;
}
export function getNotificationTitle(notification, fallback) {
    if (isNotificationOfType(notification, 'channel') &&
        notification.title === notification.source.name) {
        return notification.description || fallback;
    }
    return notification.title;
}
